/**
 * Confirm.jsx
 *
 * @Author: jruif
 * @Date: 2017/7/11 下午5:28
 */

import React, { isValidElement, cloneElement } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import Modal from './Modal';
import statusIcons from '../icons/statusIcons';
import Button from '../button';

/**
 * @ignore
 */
class ConfirmModal extends React.Component {
  static defaultProps = {
    modalProps: {},
    prefixCls: 'ne-confirm',
  };

  constructor(props) {
    super();
    this.state = {
      isOpen: false,
      loading: false,
      modalProps: props.modalProps,
    };
  }

  open = modalProps => {
    this.setState({ isOpen: true });
    if (modalProps) this.update(modalProps);
  };

  update = modalProps => {
    this.setState({ modalProps });
  };

  close = () => {
    this.setState({ isOpen: false, loading: false });
  };

  handleCancel = e => {
    const { modalProps } = this.state;
    const { onCancel } = modalProps;
    let close = false;
    if (onCancel) {
      close = onCancel(e);
    }
    if (!close) {
      this.close();
    } else if (close.then) {
      close.then(this.close).catch(() => {
        this.setState({
          loading: false,
        });
      });
    }
  };

  handleSure = e => {
    const { modalProps } = this.state;
    const { onSure } = modalProps;
    let close = false;
    if (onSure) {
      close = onSure(e);
    }
    if (!close) {
      this.close();
    } else if (close.then) {
      this.setState({
        loading: true,
      });
      close.then(this.close).catch(() => {
        this.setState({
          loading: false,
        });
      });
    }
  };

  render() {
    const { prefixCls } = this.props;
    const { isOpen, modalProps, loading } = this.state;
    const {
      size,
      type,
      actionsRender,
      title,
      content,
      icon,
      children,
      hideCloseButton,
      hideBackdrop,
      ...other
    } = modalProps;
    const StatusIcon = statusIcons[type];
    return (
      <Modal
        hideBackdrop={hideBackdrop}
        className={classNames(prefixCls, { [`${prefixCls}-${type}`]: type })}
        size={size}
        hideCloseButton={hideCloseButton}
        isOpen={isOpen}
        onClose={this.close}
        {...other}>
        <div
          className={classNames(`${prefixCls}-body`, {
            [`${prefixCls}-body-full-width`]: title,
          })}>
          {icon && isValidElement(icon) ? (
            cloneElement(icon, {
              className: classNames(`${prefixCls}-icon`, icon.props.className),
            })
          ) : StatusIcon ? (
            <StatusIcon className={`${prefixCls}-icon`} size="large" />
          ) : null}
          <div className={`${prefixCls}-container`}>
            {title ? <h6 className={`${prefixCls}-title`}>{title}</h6> : null}
            <div className={`${prefixCls}-description`}>{content || children}</div>
          </div>
        </div>
        <div className={classNames(`${prefixCls}-actions`)}>
          {actionsRender
            ? actionsRender(this.close)
            : [
                type === 'confirm' ? (
                  <Button onClick={this.handleCancel} size={size} key="cancel">
                    取消
                  </Button>
                ) : null,
                <Button
                  color="primary"
                  loading={loading}
                  variant="contained"
                  onClick={this.handleSure}
                  key="sure">
                  确认
                </Button>,
              ]}
        </div>
      </Modal>
    );
  }
}

const defaultProps = {
  disableBackdropClick: true,
  hideBackdrop: true,
  hideCloseButton: true,
  animationName: 'slide-down',
  type: 'confirm',
};
const confirm = {
  createConfirm(callback) {
    const root = document.body;
    const containerElement = document.createElement('div');
    // 不在DOM中创建节点
    root.appendChild(containerElement);
    let mounted = false;
    function getModal(modal) {
      if (mounted) {
        return;
      }
      mounted = true;
      callback &&
        callback({
          element: modal,
          destroy() {
            ReactDOM.unmountComponentAtNode(containerElement);
            containerElement.parentNode.removeChild(containerElement);
          },
        });
    }
    ReactDOM.render(<ConfirmModal {...defaultProps} ref={getModal} />, containerElement);
  },
  open(itemProps) {
    const props = Object.assign({}, defaultProps, itemProps);
    if (this.confirm) {
      this.confirm.element.open(props);
    } else {
      this.createConfirm(confirmModal => {
        confirm.confirm = confirmModal;
        confirmModal.element.update(props);
        confirmModal.element.open();
      });
    }
  },
  config(newConfig) {
    Object.assign(defaultProps, newConfig);
  },
  destroy() {
    if (this.confirm) {
      this.confirm.destroy();
      delete this.confirm;
    }
  },
};

export default confirm;



// WEBPACK FOOTER //
// ./src/modal/Confirm.jsx